<script>
import BaseSearchOther from './BaseSearchOther.vue';

export default {
  name: 'question-base-search-vehicle-model',
  extends: BaseSearchOther,
  props: {
    vehicleSystemType: {
      type: String,
      default: null,
    },
    vehicleMake: {
      type: String,
      default: null,
    },
  },

  watch: {
    'stepData.importcarMake' () {
      this.onSearch();
    },
  },

  methods: {
    async onSearch () {
      if (this.optionsConfig?.options) return;

      if (['OTHER - NOT LISTED', null].includes(this.stepData[this.vehicleMake])) return;

      try {
        const vehicleSystemType = [];
        vehicleSystemType.push(this.constants.VEHICLE_SYSTEM_TYPES[this.vehicleSystemType]);

        const response = await this.$api.searchVehicle(
          vehicleSystemType,
          { makeKey: this.stepData[this.vehicleMake] },
        );

        if (response.status === 'success') {
          this.searchItems = Object.keys(response.data).map(item => ({
            value: item,
            text: item,
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
